import axios from "axios";

export const fetcher = axios.create();

export const configFetcher = ({ authToken }: { authToken: string }) => {
  fetcher.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
};

export const cleanFetcher = () => {
  delete fetcher.defaults.headers.common["Authorization"];
};
